<div class="wiz-box">
  <div class="heading">{{'wizard.step-6.title' | translate}}</div>

  <div class="wiz-content">
    <ng-container  *ngIf="!showResultPage; then importPart; else resultPart">
    </ng-container>
  </div>
  <div class="wiz-footer">
    <button class="secondary-btn" (click)="back(showImport)"><i
      class="fas fa-chevron-left"></i><span>{{'wizard.step-6.btn-back' | translate}}</span></button>
    <button class="primary-btn" routerLink="/plugplay/step-7/check"
            [disabled]="isImportInProgress" (click)="next(showImport)"><span>{{'wizard.step-6.btn-continue' | translate}}</span>
      <i class="fas fa-chevron-right"></i></button>
  </div>
</div>
  <ng-template #resultPart>
    <div class="result-success">
      <div class="result-success-icon">
        <i class="far fa-check-circle"></i>
      </div>
      <div class="result-success-title">
        {{'wizard.step-6.import.p-1' | translate}}
      </div>
      <p>
        {{'wizard.step-6.import.p-2' | translate}}
      </p>
    </div>
  </ng-template>

<ng-template #importPart>
    <p class="my-2 mb-3 text-muted">
      {{'wizard.step-6.p-1' | translate}}
    </p>
    <div class="num-item">
      <div class="num-item-top">
        <div class="num-item-num">1.</div>
        <p>
          <strong>{{'wizard.step-6.download.p-1' | translate}}</strong>
          <p-progressSpinner *ngIf="exportLoading; else link" class="small-spinner"></p-progressSpinner>
          <ng-template #link>
            <span class="link-red ml-1" (click)="downloadFile()">{{'wizard.step-6.download.p-2' | translate}}</span> {{'wizard.step-6.download.p-3' | translate}}
<!--            <a [href]="exportUrl" download="stock-import.xlsx">{{'wizard.step-6.download.p-2' | translate}}</a>{{'wizard.step-6.download.p-3' | translate}}-->
          </ng-template>
        </p>
      </div>
    </div>
    <div class="num-item">
      <div class="num-item-top">
        <div class="num-item-num">2.</div>
        <label ngx-dropzone [disabled]="showProgress" (change)="selected($event)" for="upload2" class="styled-upload" [ngClass]="{'border-start': showStart, 'border-end': !showStart}">
          <ngx-dropzone-label *ngIf="!file" class="dropzone-label">
            <div class="d-flex  align-items-center">
              <span class="icon"></span>
              <div class="dropzone-label-text">
                <span>{{'wizard.step-5.import' | translate}}</span>
                <span>{{'wizard.step-5.import-2' | translate}}</span>
              </div>
            </div>
          </ngx-dropzone-label>
          <ngx-dropzone-label *ngIf="file" class="dropzone-label">
            <div class="d-flex align-items-center">
              <span class="icon"></span>
              <div class="dropzone-label-text uploaded">
                <span>{{ "wizard.step-6.load-success"| translate }}</span>
                <span>{{this.file.name}}</span>
              </div>
            </div>
          </ngx-dropzone-label>
        </label>
      </div>
    </div>

    <div>
      <div *ngIf="showStart; then thenBlock else elseBlock"></div>
      <ng-template #thenBlock>
        <div class="num-item">
          <div class="num-item-top">
            <div class="num-item-num">3.</div> {{'wizard.step-6.confirm-import' | translate}}
          </div>
        </div>
      </ng-template>
      <ng-template #elseBlock>
        <div class="num-item">
          <div class="num-item-top">
            <div class="num-item-num">3.</div>
            <p>
              {{'wizard.step-6.result' | translate}}
            </p>
          </div>
          <div *ngIf="itemCount > 0 && itemCount > errorMap.size" class="wiz-line-list">
            <div class="wiz-line-item"><span>{{'wizard.step-6.total-records' |
                translate}}</span><span>{{itemCount}}</span></div>
            <div class="wiz-line-item"><span>{{'wizard.step-6.ok-records' |
                translate}}</span><span>{{itemCount-errorMap.size}}</span></div>
            <div class="wiz-line-item">
              <span>{{'wizard.step-6.not-ok-records' |translate}}</span>
              <span [ngClass]="{'text-success': errorMap.size === 0, 'text-danger': errorMap.size > 0}">{{errorMap.size}}</span></div>
          </div>
          <div *ngIf="itemCount > 0 && itemCount === errorMap.size" class="text-red">
            {{'wizard.step-6.all-errors' | translate}}
          </div>
          <button *ngIf="itemCount > 0 && itemCount === errorMap.size" class="red-link"
                  (click)="showInvalidData()">{{'wizard.step-6.btn-show-not-ok-records' | translate}}</button>
          <div *ngIf="!itemCount" class="text-red">
            {{'wizard.step-6.no-data' | translate}}
          </div>
          <div class="wiz-import-btns" *ngIf="itemCount > 0 && itemCount > errorMap.size">
            <div [ngClass]="{'w-50': errorMap.size !== 0, 'w-100': errorMap.size === 0}">
              <p-progressBar *ngIf="showProgress; else elseBlock" [color]="'#ED1C24'" [showValue]="false"
                             [value]="progressValue/(itemCount-errorMap.size)*100">
              </p-progressBar>
              <ng-container *ngIf="showProgress">{{progressValue}}/{{itemCount-errorMap.size}}</ng-container>
            </div>
            <ng-template #elseBlock><button class="primary-btn" (click)="import()">{{'wizard.step-6.btn-import' |
                translate}}</button></ng-template>
            <button *ngIf="errorMap.size !== 0" class="red-link"
              (click)="showInvalidData()">{{'wizard.step-6.btn-show-not-ok-records' | translate}}</button>
          </div>
          <div *ngIf="showSkipMessage && errorMap.size > 0 && errorMap.size !== itemCount" class="skip-row-text">{{'wizard.step-6.not-ok-rows-omit' | translate}}</div>
        </div>
      </ng-template>
    </div>
</ng-template>

